import { P2Accordion, P2TextDescription, P2TextLabel } from 'react-bootstrap-common-script'
import { Separator } from '../../separator'
import AccordionTitleAmoount from '../../accordion/accordion-title-amount/accordion-title-amount'
import { InfoCard } from '../../info'
import { InfoCircle } from '../../../assets/svg'
import AdjustFPInputGroup from '../../HOC/adjust-fp-input-group/adjust-fp-input-group'
import { Helpers } from '../../../utils/helper'
import { useMemo } from 'react'

const AdjustProposedRepaymentPlanSection = () => {

  const payableByCPF = useMemo(() => {
    //CALCULATE
    return "0";
  }, [])
  const payableByCash = useMemo(() => {
    //CALCULATE
    return "0";
  }, [])



  return (
    <div>
      <P2TextDescription color='#333' title={"Proposed Loan Repayment Plan"} />
      <div className='mt-3'>
        <P2TextLabel color='#333' fontSize={"1.125rem"} bold={400} label={"Feel free to adjust your monthly instalment and Home Protection Scheme coverage below. Your repayment plan will automatically update to meet the payment required."} />
      </div>


      <div style={{ paddingTop: "32px", display: 'flex', flexDirection: "column", gap: 32 }}>
        <P2Accordion
          defaultOpen={true}
          title={<AccordionTitleAmoount title='Monthly Installment' description='$XXXXXX / month' />}
        >
          <Separator />
          <div style={{ paddingTop: "32px", display: 'flex', flexDirection: "column", gap: 32 }}>

            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
              <P2TextLabel fontSize={"1.125rem"} bold={700} label={"Payable by CPF"} />
              <P2TextLabel fontSize={"1.125rem"} bold={700} label={`${Helpers.formatThousandSeparator(payableByCPF, "$")} / month`} />
            </div>
            <div style={{ display: 'flex', flexDirection: "column", gap: 32 }}>
              {/* <AdjustFPInputGroup title='Owner 1' maxLabel='Maximum amount :' maxValue={8888} prefix='$' postfix='/ month' hasDecimal />
              <AdjustFPInputGroup title='Owner 2' maxLabel='Maximum amount :' maxValue={8888} prefix='$' postfix='/ month' hasDecimal /> */}
            </div>
            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
              <P2TextLabel fontSize={"1.125rem"} bold={700} label={"Payable by Cash"} />
              <P2TextLabel fontSize={"1.125rem"} bold={700} label={`${Helpers.formatThousandSeparator(payableByCash, "$")} / month`} />
            </div>
          </div>
        </P2Accordion>

        <P2Accordion
          defaultOpen={true}
          title={<AccordionTitleAmoount title='Home Protection Scheme Coverage' />}
        >
          <Separator />
          <div style={{ paddingTop: "32px", display: 'flex', flexDirection: "column", gap: 32 }}>

            <div style={{ display: 'flex', flexDirection: "column", gap: 32 }}>
              {/* <AdjustFPInputGroup inputVariant='small' title='Owner 1' minLabel='Minimum amount' maxLabel='Maximum amount' minValue={1} maxValue={100} postfix='%' hasDescription descriptionContent='1st year premium (by CPF): $332.10' />
              <AdjustFPInputGroup inputVariant='small' title='Owner 2' minLabel='Minimum amount' maxLabel='Maximum amount' minValue={1} maxValue={100} postfix='%' hasDescription descriptionContent='1st year premium (by CPF): $332.10' /> */}
            </div>
            <InfoCard icon={<InfoCircle />} description={<p>Default coverage is 100% for each owner, but can be reduced, provided the household’s total coverage remains at least 100%.</p>} />

          </div>
        </P2Accordion>

      </div>

    </div>
  )
}

export default AdjustProposedRepaymentPlanSection